module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "w-6 h-6 stroke-current text-blue-dark"
  }, [_c('g', {
    staticClass: "nc-icon-wrapper",
    attrs: {
      "transform": "translate(.5 .5)",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "data-color": "color-2",
      "cx": "7",
      "cy": "21",
      "r": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "data-color": "color-2",
      "cx": "19",
      "cy": "21",
      "r": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "data-cap": "butt",
      "d": "M4.667 6H22l-2 10H6L4 1H1"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-342a7256","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar/sidemenu/svgs/SupplyOrderSVG.vue
// module id = 615
// module chunks = 66